import React from "react";

import {
    UtensilsCrossed,
    Globe,
    Mail,
    Phone,
    Code,
    Heart,
    ChevronRight
} from "lucide-react";

import "./DeliveryAbout.css";

function DeliveryAbout() {

    const details = [

        {
            title: "App Version",
            value: "1.0.0",
            icon: <UtensilsCrossed size={22} />,
        },

        {
            title: "Website",
            value: "www.homefoods.in",
            icon: <Globe size={22} />,
        },

        {
            title: "Support Email",
            value: "support@homefoods.in",
            icon: <Mail size={22} />,
        },

        {
            title: "Support Number",
            value: "+91 99999 99999",
            icon: <Phone size={22} />,
        },

        {
            title: "Developed By",
            value: "HomeFoods Team",
            icon: <Code size={22} />,
        },

    ];

    return (

        <div className="delivery-about-page">

            <div className="about-header">

                <div className="about-logo">

                    🍱

                </div>

                <h1>

                    HomeFoods

                </h1>

                <p>

                    Fresh. Homemade. Delivered.

                </p>

            </div>

            <div className="about-card">

                {

                    details.map((item, index) => (

                        <div
                            key={index}
                            className="about-item"
                        >

                            <div className="about-left">

                                <div className="about-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h3>

                                        {item.title}

                                    </h3>

                                    <p>

                                        {item.value}

                                    </p>

                                </div>

                            </div>

                            <ChevronRight size={18} />

                        </div>

                    ))

                }

            </div>

            <div className="about-footer">

                <Heart
                    size={18}
                    fill="#ef4444"
                    color="#ef4444"
                />

                <span>

                    Made with ❤️ in India

                </span>

            </div>

            <div className="copyright">

                © 2026 HomeFoods. All Rights Reserved.

            </div>

        </div>

    );

}

export default DeliveryAbout;